var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ZyroButton',{staticClass:"toggle-control",class:{ 'toggle-control--enabled': _vm.isStyleEnabled },attrs:{"border-radius":"0","icon":_vm.toggleValue},on:{"click":_vm.toggleStyle}})}
var staticRenderFns = []

export { render, staticRenderFns }